import { PrinterAdapter } from '@/features/print/adapters/types'
import { ErrorCode } from '@/features/print/constants'
import { PrinterError } from '@/features/print/errors'
import SunmiPrinter, { SunmiPrinterErrorCode } from '@/modules/sunmi-printer'
import { CodedError } from 'expo-modules-core'

export class SunmiPrinterAdapter implements PrinterAdapter {
    async print(data: Buffer): Promise<void> {
        try {
            await SunmiPrinter.sendEscPosCommands(data.toString('base64'))
        } catch (error) {
            if (error instanceof CodedError) {
                switch (error.code) {
                    case SunmiPrinterErrorCode.PrinterUnavailable:
                    case SunmiPrinterErrorCode.PrinterDiscovery:
                        throw new PrinterError(ErrorCode.SunmiPrinterUnavailable, undefined, error)
                    case SunmiPrinterErrorCode.PrinterOperation:
                        throw new PrinterError(ErrorCode.SunmiPrinterOperation, undefined, error)
                }
            }

            throw error
        }
    }
}
